/**
 * usePayrollRuns — React Query hook a bérszámfejtési futtatások listájához
 */

import { useQuery } from '@tanstack/react-query';
import { listRuns, type ListPayrollRunsFilter, type PayrollRunDto } from '../api/payroll-api';

export function usePayrollRuns(filter?: ListPayrollRunsFilter) {
  return useQuery<PayrollRunDto[]>({
    queryKey: ['payroll', 'runs', filter],
    queryFn: async () => {
      const res = await listRuns(filter);
      return res.data;
    },
    staleTime: 30_000,
  });
}
